<template>
	<div>
		<headful
			:title="'Caseen - ' + (editorMode ? 'Editor' : 'Learner') + ' Case List'"
		/>
		<!--Heading -->
		<h1 v-if="!userProfile">
			{{(editorMode ? 'Editor' : 'Learner')}} - Case List
		</h1>
		<div style="position: relative;">
			<md-button class="md-icon-button md-primary md-raised case-settings-btn" @click="showFilters = !showFilters">
				<md-icon>filter_list</md-icon>
				<md-tooltip md-direction="left">Filter Cases</md-tooltip>
			</md-button>
		</div>
		<hr>
		<!-- Filter Options -->
		<div v-show="showFilters" @change="filterChange">
			<div class="filter-bar">
				<md-field>
					<label>Search:</label>
					<md-input v-model="caseFilters.search" @change="filterChange"></md-input>
				</md-field>
			</div>
			<div class="filter-bar">
				<md-checkbox v-model="caseFilters.archived" v-if="editorMode" @change="filterChange">
					Show Archived
				</md-checkbox>
				<md-checkbox v-model="caseFilters.completed" v-if="!editorMode" @change="filterChange">
					Show Completed
				</md-checkbox>
			</div>
			<!-- Quality + Difficulty Sliders -->
			<div class="filter-bar" style="justify-content: space-around">
				<div>
					<div style="margin-bottom: 8px; font-weight: bold; user-select: none;">
						Quality: {{caseFilters.qualityRange[0].toFixed(1)}} to {{caseFilters.qualityRange[1].toFixed(1)}}
					</div>
					<RangeSlider :values="caseFilters.qualityRange" 
						@change="filterChange"
						:config="{
						'step': .1,
						'connect': [false, true, false],
						'range': {
						'min': [ 0 ],
						'max': [ 5 ]
						}
					}"/>
				</div>
				<div>
					<div style="margin-bottom: 8px; font-weight: bold; user-select: none;">
						Difficulty: {{caseFilters.difficultyRange[0].toFixed(1)}} to {{caseFilters.difficultyRange[1].toFixed(1)}}
					</div>
					<RangeSlider :values="caseFilters.difficultyRange" 
						@change="filterChange"
						:config="{
						'step': .1,
						'connect': [false, true, false],
						'range': {
						'min': [ 0 ],
						'max': [ 3 ]
						}
					}"/>
				</div>
			</div>
			<hr>
		</div>
		<div v-if="editorMode">
			<md-button class="md-primary md-raised" @click="createCase()">
				Create a New Case
			</md-button>
			<hr>
		</div>
		<md-empty-state v-if="serverError != undefined" md-icon="error" :md-label="'Server Error: ' + serverError"
		md-description="Could not fetch case data from server!">
		</md-empty-state>
		<div class="case-list" v-if="serverError == undefined && showCaseList">
			<md-empty-state v-show="caseList.length < 1" md-icon="layers_clear" md-label="No cases found!">
			</md-empty-state>
			<div v-for="c in caseList" :key="c.id" v-if="isQualified(c.id)" class="card-container">
				<div class="vert-center">
					<md-card :class="{'archived': c.archived || (!editorMode && Object.keys(myCaseReviews).includes(c.id))}">
						<router-link :to="'/' + (editorMode ? 'editor' : 'cases') + '/' + c.id">
							<md-card-media>
								<img class="thumbnail" :src="c.thumbnail.res_url" alt="thumbnail.name" v-if="c.thumbnail && c.thumbnail.res_url">
							</md-card-media>
							<md-card-header style="margin-bottom: -8px;">
								<div style="letter-spacing: 0; line-height: 125%; font-size: 135%;">{{c.title}}</div>
								<div v-if="c.archived" style="text-decoration: none;">(Archived)</div>
								<div v-if="!editorMode && Object.keys(myCaseReviews).includes(c.id)" style="text-decoration: none;">(Completed)</div>
							</md-card-header>
						</router-link>
						<div v-if="aggCaseReviews[c.id]">
							<hr>
							<!--<div style="margin-bottom: 10px">
							</div>-->
							<!-- Case Review -->
							<div style="display: flex; justify-content: space-around;">
								<md-tooltip md-direction="top" style="font-size: 120%;">
									&nbsp;
									{{aggCaseReviews[c.id].attempt}} Review<span v-if="aggCaseReviews[c.id].attempt > 1">s</span>
									&nbsp;
								</md-tooltip>
								<div style="display: inline-block">
										<star-rating
											read-only
											v-model="aggCaseReviews[c.id].quality"
											:show-rating="false"
											:max-rating="5" 
											:increment="0.1"
											:star-size="18" 
											style="display: inline-block">
										</star-rating>
									<br>
									Quality: {{aggCaseReviews[c.id].quality.toFixed(1)}}
								</div>
								<div style="display: inline-block">
										<star-rating 
											read-only
											v-model="aggCaseReviews[c.id].difficulty" 
											:show-rating="false"
											:max-rating="3" 
											:increment="0.1"
											:star-size="18" 
											style="display: inline-block">
										</star-rating>
									<br>
									Difficulty: {{aggCaseReviews[c.id].difficulty.toFixed(1)}}
								</div>
							</div>
						</div>
						<hr style="margin-bottom: 0px">
						<md-card-expand>
							<md-card-actions md-alignment="space-between">
								<md-button class="md-icon-button" v-if="editorMode" @click="$router.push('/editor/' + c.id + '/dashboard')">
									<md-icon>assessment</md-icon>
								</md-button>
								<div style="font-weight: bold; font-size: 85%; margin-left: 15px;">
									<md-tooltip v-if="peerReviews[c.id]" style="word-wrap: break-word !important; height: auto; text-align: center;">
										{{peerReviews[c.id].accept}} Educator Approval{{peerReviews[c.id].accept != 1 ? "s" : ""}}
										<br>
										<div v-if="peerReviews[c.id].expiredAccept > 0">										
											{{peerReviews[c.id].expiredAccept}} Out-of-Date Educator Approval{{peerReviews[c.id].expiredAccept != 1 ? "s" : ""}}
										</div>
										<div v-if="peerReviews[c.id].reject > 0">
											{{peerReviews[c.id].reject}} Educator Rejection{{peerReviews[c.id].reject != 1 ? "s" : ""}}
										</div>
									</md-tooltip>
									<span v-html="educatorCaseTag(c)" />
								</div>
								<md-card-expand-trigger>
									<md-button class="md-icon-button">
										<md-icon>keyboard_arrow_down</md-icon>
									</md-button>
								</md-card-expand-trigger>
							</md-card-actions>
							<md-card-expand-content>
								<md-card-content style="padding: 0 10px 24px 10px;">
									<span>
										Created: {{objectIDTimestamp(c.id)}}
										<br>
										Last Edited: {{c.last_edited? objectIDTimestamp(c.last_edited) : "Unknown"}}
										<br>
										Owner: <a :href="'/user/' + c.authors[0].pid">{{c.authors[0].uname}}#{{c.authors[0].pid.slice(0, 5)}}</a>
									</span>
									<div v-if="c.description">
										<hr>
										<i>{{c.description}}</i>
									</div>
								</md-card-content>
							</md-card-expand-content>
						</md-card-expand>
					</md-card>
				</div>
			</div>
		</div>
		<md-progress-spinner 
			:md-diameter="100" 
			:md-stroke="10" 
			md-mode="indeterminate"
			v-show="!showCaseList && serverError == undefined">
		</md-progress-spinner>
	</div>
</template>

<script>

import APIRequests from "./APIRequests.js"

import RangeSlider from "./RangeSlider.vue"
import StarRating from 'vue-star-rating'

const ObjectID = require("bson-objectid");

function formatDate(date) {
	var hours = date.getHours();
	var minutes = date.getMinutes();
	var ampm = hours >= 12 ? 'pm' : 'am';
	hours = hours % 12;
	hours = hours ? hours : 12; // the hour '0' should be '12'
	minutes = minutes < 10 ? '0'+minutes : minutes;
	var strTime = hours + ':' + minutes + ' ' + ampm;
	return date.getMonth()+1 + "/" + date.getDate() + "/" + date.getFullYear() + " at " + strTime;
}

export default {
	components: { 
		RangeSlider,
		StarRating
	},
	props: {
		userProfile: {
			type: String,
		}
	},
	data: function( ){
		return{
			caseList: [],
			aggCaseReviews: {},
			myCaseReviews: {},
			peerReviews: {},
			showCaseList: false,
			showFilters: false,
			caseFilters: {
				archived: this.$route.query.archived == "false" ? false : true,
				completed: this.$route.query.completed == "false" ? false : true,
				search: this.$route.query.search,
				qualityRange: this.getQualityRange(),
				difficultyRange: this.getDifficultyRange(),
			}, 
			creatingCase: false,
			serverError: undefined
		}
	},
	methods: {
		educatorCaseTag: function(caseEntry){
			let educatorAuthor = caseEntry.authors.some((author) => author.isEducator)
			let peerAccepts = this.peerReviews[caseEntry.id] ? this.peerReviews[caseEntry.id].accept : 0
			if(!educatorAuthor && !peerAccepts){
				return ""
			}
			let tag = "Educator"
			if(educatorAuthor) tag += " Authored"
			if(educatorAuthor && peerAccepts) tag += " +"
			if(peerAccepts) tag += " Reviewed"
			return tag
		},
		isQualified: function(caseID){
			let qualityRating = this.aggCaseReviews[caseID] ? this.aggCaseReviews[caseID].quality : 0
			let difficultyRating = this.aggCaseReviews[caseID] ? this.aggCaseReviews[caseID].difficulty : 0
			if(qualityRating < this.caseFilters.qualityRange[0] || qualityRating > this.caseFilters.qualityRange[1]){
				return false
			}
			if(difficultyRating < this.caseFilters.difficultyRange[0] || difficultyRating > this.caseFilters.difficultyRange[1]){
				return false
			}
			if(!this.editorMode && !this.caseFilters.completed && Object.keys(this.myCaseReviews).includes(caseID)){
				return false
			}
			return true
		},
		getQualityRange: function(){
			if(this.$route.query.quality && this.$route.query.quality.split(",").length == 2){
				let low = parseFloat(this.$route.query.quality.split(",")[0])
				let high = parseFloat(this.$route.query.quality.split(",")[1])
				if(!isNaN(low) && !isNaN(high)){
					return [low, high]
				}
			}
			return [0, 5]
		},
		getDifficultyRange: function(){
			if(this.$route.query.difficulty && this.$route.query.difficulty.split(",").length == 2){
				let low = parseFloat(this.$route.query.difficulty.split(",")[0])
				let high = parseFloat(this.$route.query.difficulty.split(",")[1])
				if(!isNaN(low) && !isNaN(high)){
					return [low, high]
				}
			}
			return [0, 3]
		},
		objectIDTimestamp: function(objid){
			const timestamp = ObjectID.createFromHexString(objid).getTimestamp()
			return formatDate(timestamp)
		},
		filterChange: function(){
			this.$router.push(this.$route.path + this.constructFilterQuery(false)) 
		},
		constructFilterQuery: function(apiCall=true){
			var filterQuery = "?"
			var filtersChosen = false
			if(this.editorMode){
				if(this.caseFilters.archived == false){
					filterQuery += "&archived=false"
					filtersChosen=true
				} else {
					filterQuery += "&archived=true"
				}
				if(apiCall){
					filterQuery += "&completed=true"
				}
			}
			else {
				if(this.caseFilters.completed == false){
					filterQuery += "&completed=false"
					filtersChosen=true
				} else {
					filterQuery += "&completed=true"
				}
				if(apiCall){
					filterQuery += "&archived=false"
				}
			}
			//Filter by quality
			if(this.caseFilters.qualityRange && JSON.stringify(this.caseFilters.qualityRange) != JSON.stringify([0,5])) {
				filterQuery += "&quality=" + this.caseFilters.qualityRange
				filtersChosen = true
			}
			//Filter by difficulty
			if(this.caseFilters.difficultyRange && JSON.stringify(this.caseFilters.difficultyRange) != JSON.stringify([0,3])) {
				filterQuery += "&difficulty=" + this.caseFilters.difficultyRange
				filtersChosen = true
			}
			//Filter by creator
			if(this.userProfile) {
				filterQuery += "&createdBy=" + this.userProfile
			}
			if(this.caseFilters.search) {
				filterQuery += "&search=" + this.caseFilters.search
				filtersChosen = true
			}
			if(filtersChosen) this.showFilters = true
			return filterQuery
		},
		updateReviewData: function(){
			return new Promise((resolve, reject) => {
				let caseIDList = this.caseList.map((x) => x.id)
				let api_url = this.$store.state.api_url + "/api/reviews/byID"
				APIRequests.postJSONData(
					api_url, 
					caseIDList,
					this.$store.state.jwtToken
				).then((data) => {
					if(!data){
						data = {}
					}
					let aggCaseReviews = {}
					if(Array.isArray(data.aggReviews)){
						data.aggReviews.forEach((caseEntry) => {
							aggCaseReviews[caseEntry.id] = caseEntry
						})
					}
					this.aggCaseReviews = aggCaseReviews;

					let myCaseReviews = {}
					if(Array.isArray(data.myReviews)){
						data.myReviews.forEach((caseEntry) => {
							myCaseReviews[caseEntry.cid] = caseEntry
						})
					}
					let peerReviews = {}
					if(Array.isArray(data.peerReviews)){
						data.peerReviews.forEach((reviewEntry) => {
							if(!peerReviews[reviewEntry.cid]) peerReviews[reviewEntry.cid] = {accept: 0, expiredAccept: 0, reject: 0}
							if(reviewEntry.peerAccept) {
								if(reviewEntry.expired){
									peerReviews[reviewEntry.cid].expiredAccept ++
								} else {
									peerReviews[reviewEntry.cid].accept ++
								}
							}
							if(reviewEntry.peerReject) peerReviews[reviewEntry.cid].reject ++						
						})
					}
					this.myCaseReviews = myCaseReviews
					this.peerReviews = peerReviews;
					this.serverError = undefined;
					resolve()
				}).catch(([xhrStatus, xhrResp]) => {
					this.serverError = xhrStatus
					reject([xhrStatus, xhrResp])
				})
			})
		},
		updateCaselist: function(){
			return new Promise((resolve, reject) => {
				let api_url = this.$store.state.api_url + "/api/cases/" + this.constructFilterQuery(true)
				if(this.$route.path == '/editor') api_url += "&editable=true"
				APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
					if(!data){
						data = []
					}
					this.caseList = data;
					this.serverError = undefined;
					resolve()
				}).catch(([xhrStatus, xhrResp]) => {
					this.serverError = xhrStatus
					reject([xhrStatus, xhrResp])
				}).then(() => {
					return this.updateReviewData()
				})
			})
		},
		createCase: function(){
			if(!this.creatingCase){
				if(!confirm("Start creating a new case?")){
					return
				}
				this.creatingCase = true
				var api_url = this.$store.state.api_url + "/api/editor/createCase";
				APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
					this.$router.push("/editor/" + data.id)
				}).catch(() => {
					alert("Error creating new case.")
					this.creatingCase = false
				})
			}
		},
	},
	computed: {
		editorMode: function() { 
			return this.$route.path == '/editor'
		}
	},
	watch:{
		$route (to, from){
			if(to.path != from.path){
				this.caseFilters = {}
				this.$set(this.caseFilters, "qualityRange", this.getQualityRange())
				this.$set(this.caseFilters, "difficultyRange", this.getDifficultyRange())
			}
			let watchTo = [to.path, to.query.archived, to.query.search]
			let watchFrom = [from.path, from.query.archived, from.query.search]
			if(JSON.stringify(watchTo) != JSON.stringify(watchFrom)){
				this.showCaseList = false;
				this.updateCaselist().then(() => {
					setTimeout(() => {this.showCaseList = true}, 500)
				}).catch(() => {})
			}
		}
	}, 
	mounted: function(){
		this.$nextTick(function () {
			this.updateCaselist().then(() => {
				setTimeout(() => {this.showCaseList = true}, 500)
			}).catch(() => {})
		})
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.case-list{
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		padding: 10px;
	}
	.card-container{
		width: 30%;
		min-width: 280px;
		margin: 0px 10px;
	}
	.vert-center{
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.md-card {
		max-width: 300px;
		width: 100%;
		margin: 15px 30px;
		display: inline-block;
		vertical-align: top;
	}
	.md-card, .md-card-actions{
		background-color:rgb(240, 240, 235) !important;
	}
	.md-card.archived, .archived .md-card-actions {
		background-color:rgb(205, 205, 195) !important;
	}
	a{
		color: #2c3e50 !important;
	}
	.thumbnail {
		width: 100%;
		max-height: 180px;
		object-fit: cover;
	}
	.filter-bar{
		display : flex;
		justify-content: center;
		margin-bottom: 15px;
		flex-wrap: wrap;
	}
	.filter-bar .md-field {
		width: 230px !important;
		margin: auto;
	} 
	.case-settings-btn{
		position: absolute;
		top: -52px;
		right: 15px;
	}
</style>
